export const getItemBadges = (badgeIds: string[], prevState: any) => {
  const badges = prevState?.settings?.data?.messages;
  const foundBadges = badgeIds?.map((badgeId) => badges[`catalog.product.badge.${badgeId}`]);
  return foundBadges?.filter((badge) => badge !== undefined).join(',');
};
